import {
	GET_INSURANCE_DROPDOWN,
	GET_INSURANCE_DROPDOWN_SUCCESS,
	GET_INSURANCE_DROPDOWN_FAIL,
	GET_INSURANCE_DROPDOWN_RESET,
} from '../actions/getInsuranceDropdownAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getInsuranceDropdownReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_INSURANCE_DROPDOWN:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_INSURANCE_DROPDOWN_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_INSURANCE_DROPDOWN_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_INSURANCE_DROPDOWN_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getInsuranceDropdownReducer;
